import type { SignupStep } from './steps';

/**
 * The funnel's step-ordering logic. All pure — the flow provider is a thin
 * stateful shell over these. Only the consolidated sequence is supported
 * (the legacy route maps / cookie / `?signupFlow=` override are not ported).
 */
export type FlowSequenceContext = {
  isStartup: boolean;
  isGoogleSignup: boolean;
};

export function buildRouteSequence({ isStartup, isGoogleSignup }: FlowSequenceContext): SignupStep[] {
  const steps: SignupStep[] = ['index'];
  if (!isGoogleSignup) {
    steps.push('confirmation', 'password');
  }
  if (!isStartup) {
    steps.push('company');
  }
  steps.push('onboarding_usage', 'channels');
  if (isStartup) {
    steps.push('startup_complete');
  }
  return steps;
}

/**
 * The next step after `current`, or `'complete'` when the sequence is
 * exhausted. `null` when `current` isn't in the sequence — the guards bounce
 * those to the entry step.
 */
export function getNextStep(current: SignupStep, context: FlowSequenceContext): SignupStep | 'complete' | null {
  const sequence = buildRouteSequence(context);
  const index = sequence.indexOf(current);
  if (index < 0) {
    return null;
  }
  return sequence[index + 1] ?? 'complete';
}

export type ResolvedSignupType = 'startup' | 'journeys';

/** The `signup_type` the register call submits and step analytics report. */
export function resolveSignupType({ isStartup }: { isStartup: boolean }): ResolvedSignupType {
  return isStartup ? 'startup' : 'journeys';
}
